import * as React from 'react';

import { useSetAtom } from 'jotai';

import { $populateSidecarFormAction } from '../_state/sidecarForm.state';
import { SidecarDetailRecord } from '../types/sidecar';

type Props = {
  sidecar: SidecarDetailRecord | null | undefined;
};

export const usePopulateSidecarForm = ({ sidecar }: Props) => {
  const populateForm = useSetAtom($populateSidecarFormAction);

  React.useEffect(() => {
    populateForm(sidecar);
  }, [sidecar, populateForm]);
};
